<template>
  <v-fab-transition>
    <v-btn
      v-if="show"
      @click="$vuetify.goTo(target, options)"
      fixed
      bottom
      right
      fab
      small
      depressed
      color="primary"
      class="to-top-btn"
      ><v-icon size="26" color="white">mdi-chevron-up</v-icon></v-btn
    >
  </v-fab-transition>
</template>

<script>
export default {
  name: "ToTopButton",
  data: () => ({
    show: false,
    target: 0,
    options: {
      duration: 400,
      offset: 0,
      easing: "easeInCubic"
    }
  }),
  mounted() {
    window.addEventListener("scroll", () => {
      this.show = window.pageYOffset > 100;
    });
  }
};
</script>

<style lang="scss">
.v-btn.to-top-btn {
  bottom: 20px;
  right: 20px;
  height: 40px !important;

  @media (min-width: 768px) {
    bottom: 40px;
    right: 40px;
  }
}
</style>
